import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-069d65ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 px-3 pb-2" }
const _hoisted_2 = {
  key: 0,
  class: "infinite-loading-container"
}
const _hoisted_3 = {
  key: 0,
  class: "w-100 p-3 bg-white text-14 text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "my-3 text-size-14"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applications, (application) => {
        return (_openBlock(), _createBlock(_component_ApplicationCard, {
          key: application.id,
          application: application,
          onClick: ($event: any) => (_ctx.$emit('clickOrderCard', application.id)),
          class: "mb-2"
        }, null, 8, ["application", "onClick"]))
      }), 128)),
      _createTextVNode(),
      (_ctx.isInitialDataFetched)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.applications.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, "\n          お仕事はありません\n        "))
              : (!_ctx.hasNext)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, "\n          ここが最後です\n        "))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}